import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import {SERVER_URL} from "../config/config"
import Popup from "reactjs-popup";

async function loginUser(credentials) {
  try {
    const res = await fetch(SERVER_URL + "/login/access-token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(credentials),
    });

    return res.json();
  } catch (error) {
    return { networkError: true };
  }
}

export default function Login({ sessionObject }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [pageMode, setPageMode] = useState("");
  const [popupError, setPopupError] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const refStoreObject = useRef({
    username: null,
    password: null,
    save_button: null,
  });
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setPopupError("Please enter both username and password.");
      setPageMode("error");
      return;
    }

    setIsLoggingIn(true);
    const resp = await loginUser({
      username,
      password: password.toLowerCase(),
    });
    setIsLoggingIn(false);

    if (resp?.networkError) {
      setPopupError("Unable to connect to server. Please try again later.");
      setPageMode("error");
      return;
    }

    if (!resp || typeof resp !== "object") {
      setPopupError("Unable to process your login request.");
      setPageMode("error");
      return;
    }

    if ("detail" in resp) {
      setPopupError(resp.detail === "Exeption in login api" ? "Invalid credentials" : resp.detail);
      setPageMode("error");
      return;
    }

    resp.branch_id = resp.branch_id || null;
    resp.branch_name = resp.branch_name || null;

    sessionObject.saveSessionVariableByObject(resp);
  };

  useEffect(() => {
    refStoreObject.current.username?.focus();
  }, []);

  const BRAND = "#43507d";
  const BRAND_HOVER = "#54629a";

  const wrapperStyle = {
    height: "calc(100vh - 80px)",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f5f6fa",
    fontFamily:
      "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
    padding: "20px",
    boxSizing: "border-box",
  };

  const cardStyle = {
    width: "340px",
    background: "#ffffff",
    padding: "30px 24px",
    borderRadius: "12px",
    border: "1px solid #e3e6ea",
    textAlign: "center",
    boxSizing: "border-box",
    boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
  };

  const iconStyle = {
    width: "52px",
    height: "52px",
    margin: "0 auto 10px auto",
    borderRadius: "50%",
    background: "#eef0f7",
    color: BRAND,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "26px",
    fontWeight: 700,
    lineHeight: 1,
  };

  const titleStyle = {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "4px",
    color: "#222",
  };

  const subTitleStyle = {
    fontSize: "13px",
    marginBottom: "20px",
    color: "#666",
  };

  const controlBase = {
    width: "100%",
    boxSizing: "border-box",
    display: "block",
    fontSize: "15px",
    fontFamily: "inherit",
    lineHeight: "1.4",
    transition: "all 0.15s ease",
  };

  const inputBox = {
    ...controlBase,
    padding: "10px 12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    background: "#fbfbfd",
    marginBottom: "14px",
    outline: "none",
    appearance: "none",
  };

  const buttonStyle = {
    ...controlBase,
    padding: "11px 12px",
    borderRadius: "8px",
    border: `1px solid ${BRAND}`,
    background: BRAND,
    color: "white",
    cursor: isLoggingIn ? "default" : "pointer",
    fontWeight: 600,
    outline: "none",
    opacity: isLoggingIn ? 0.8 : 1,
  };

  const footerText = {
    marginTop: "18px",
    fontSize: "13px",
    color: "#777",
  };

  return (
    <div style={wrapperStyle}>
      <Popup
        open={pageMode === "error"}
        modal
        overlayStyle={{
          background: "rgba(0,0,0,0.35)",
          backdropFilter: "blur(2px)",
        }}
        contentStyle={{
          width: "400px",
          borderRadius: "14px",
          padding: "0",
          background: "transparent",
          border: "none",
        }}
        closeOnDocumentClick={false}
      >
        {(close) => (
          <div
            style={{
              background: "#ffffff",
              padding: "30px 26px 28px 26px",
              borderRadius: "14px",
              boxShadow: "0 10px 35px rgba(0,0,0,0.18)",
              textAlign: "center",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "45px",
                height: "45px",
                margin: "0 auto 12px auto",
                borderRadius: "50%",
                background: "#fee2e2",
                color: "#DC2626",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                fontWeight: 700,
                lineHeight: 1,
              }}
            >
              !
            </div>

            <div
              style={{
                fontSize: "20px",
                fontWeight: 700,
                color: "#111",
                marginBottom: "8px",
              }}
            >
              Login Error
            </div>

            <div
              style={{
                fontSize: "15px",
                color: "#444",
                marginBottom: "22px",
              }}
            >
              {popupError || "Unable to process your login request."}
            </div>

            <button
              style={{
                width: "100%",
                padding: "12px 0",
                borderRadius: "8px",
                border: `1px solid ${BRAND}`,
                background: BRAND,
                color: "white",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                outline: "none",
                transition: "0.15s ease",
              }}
              onMouseEnter={(e) => (e.target.style.background = BRAND_HOVER)}
              onMouseLeave={(e) => (e.target.style.background = BRAND)}
              onClick={() => {
                close();
                setPageMode("");
                setTimeout(() => {
                  refStoreObject.current.username?.focus();
                }, 10);
              }}
            >
              OK
            </button>
          </div>
        )}
      </Popup>

      <div style={cardStyle}>
        <div style={iconStyle}>👤</div>
        <div style={titleStyle}>Welcome Back</div>
        <div style={subTitleStyle}>Please sign in to your account</div>

      <form onSubmit={handleSubmit}>
          <input 
            type="text" 
            placeholder="Username"
            style={inputBox}
            onChange={(e) => setUserName(e.target.value)} 
            ref={(a) => refStoreObject.current.username = a}
            onFocus={(e) => {
              e.target.style.border = `1px solid ${BRAND}`;
              e.target.style.boxShadow = `0 0 0 2px rgba(67,80,125,0.25)`;
            }}
            onBlur={(e) => {
              e.target.style.border = "1px solid #d1d5db";
              e.target.style.boxShadow = "none";
            }}
            onKeyDown={(e) =>{
              if (e.key === "Enter"){
                e.preventDefault();
                refStoreObject.current.password.focus();
              }
            }}
          />

          <input
            type="password"
            placeholder="Password"
            style={inputBox}
            onChange={(e) => setPassword(e.target.value)}
            ref={(a) => refStoreObject.current.password = a}
            onFocus={(e) => {
              e.target.style.border = `1px solid ${BRAND}`;
              e.target.style.boxShadow = `0 0 0 2px rgba(67,80,125,0.25)`;
            }}
            onBlur={(e) => {
              e.target.style.border = "1px solid #d1d5db";
              e.target.style.boxShadow = "none";
            }}
            onKeyDown={(e) =>{
              if (e.key === "Enter"){
                e.preventDefault();
                refStoreObject.current.save_button.focus();
              }
            }}
          />

          <button
            type="submit"
            style={buttonStyle}
            ref={(a) => refStoreObject.current.save_button = a}
            onMouseEnter={(e) => {
              if (!isLoggingIn) e.target.style.background = BRAND_HOVER;
            }}
            onMouseLeave={(e) => (e.target.style.background = BRAND)}
            onFocus={(e) => {
              e.target.style.boxShadow = `0 0 0 2px rgba(67,80,125,0.25)`;
            }}
            onBlur={(e) => {
              e.target.style.boxShadow = "none";
            }}
            disabled={isLoggingIn}
          >
            {isLoggingIn ? "Logging in..." : "Login"}
          </button>
      </form>

        <div style={footerText}>
          Powered by{" "}
          <a
            href="https://techiteasy.co.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: BRAND,
              textDecoration: "none",
              fontWeight: "600",
            }}
            onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
            onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
          >
            Tech It Easy
          </a>
        </div>
      </div>
    </div>
  );
}

Login.propTypes = {};
